module.exports = __webpack_public_path__ + "media/images/modules/publisher/steps/2-d61dd368756d9e326e9a6eb43475dec3.png";